import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BetterBuysPageRoutingModule } from './better-buys-routing.module';

import { BetterBuysPage } from './better-buys.page';
import { SharedModule } from '../shared/shared.module';
import { BetterBuysContainerComponent } from './components/better-buys-container/better-buys-container.component';
import { BetterBuysCurrentProductCardComponent } from './components/desktop/better-buys-current-product-card/better-buys-current-product-card.component';
import { BetterBuysConversionProductCardComponent } from './components/desktop/better-buys-conversion-product-card/better-buys-conversion-product-card.component';
import { BetterBuysCurrentProductCardMobileComponent } from './components/mobile/better-buys-current-product-card-mobile/better-buys-current-product-card-mobile.component';
import { BetterBuysConversionProductCardMobileComponent } from './components/mobile/better-buys-conversion-product-card-mobile/better-buys-conversion-product-card-mobile.component';
import { BetterBuysCurrentProductCardTabletComponent } from './components/tablet/better-buys-current-product-card-tablet/better-buys-current-product-card-tablet.component';
import { BetterBuysConversionProductCardTabletComponent } from './components/tablet/better-buys-conversion-product-card-tablet/better-buys-conversion-product-card-tablet.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BetterBuysPageRoutingModule,
    SharedModule,
  ],
  declarations: [
    BetterBuysPage,
    BetterBuysContainerComponent,
    BetterBuysCurrentProductCardComponent,
    BetterBuysConversionProductCardComponent,
    BetterBuysCurrentProductCardMobileComponent,
    BetterBuysConversionProductCardMobileComponent,
    BetterBuysCurrentProductCardTabletComponent,
    BetterBuysConversionProductCardTabletComponent,
  ],
  exports: [
    BetterBuysConversionProductCardComponent,
    BetterBuysConversionProductCardMobileComponent,
    BetterBuysConversionProductCardTabletComponent,
  ],
})
export class BetterBuysPageModule {}
